// Minimal reactive app state. Cesium owns the render loop; the store holds UI state
// (connection status, active project, selected item) that panels subscribe to.
import { atom } from "nanostores";

export const $connected = atom<boolean | null>(null);
export const $backendVersion = atom<string>("");
export const $activeProjectId = atom<number | null>(null);
export const $selectedItemId = atom<number | null>(null);
export const $selectedItemName = atom<string | null>(null);
// Logged-in username, stamped onto sign-offs and comments so the audit trail shows who.
export const $user = atom<string>("");
